import { camelCaseToTitle } from "../../../../../../../helpers/StringHelper";

export const mapData = ({
  data,
  setDaily,
  setWeekly,
  setMonthly,
  keys,
}) => {
  const dailyData = [];
  const weeklyData = [];
  const monthlyData = [];

  const sourceData = { daily: {}, weekly: {}, monthly: {} };

  Object.keys(sourceData).forEach((s) => {
    keys.forEach((k) => sourceData[s][k] = data[s][k]);
  });

  Object.keys(sourceData.daily).forEach((key) => {
    let prevValue = 0;
    for (const [type, value] of Object.entries(data.daily[key])) {
      prevValue += value;
      dailyData.push({ type, value: prevValue, series: camelCaseToTitle(key), realValue: value });
    }
  });

  Object.keys(sourceData.daily).forEach((key) => {
    let prevValue = 0;
    for (const [type, value] of Object.entries(data.weekly[key])) {
      prevValue += value;
      weeklyData.push({ type, value: prevValue, series: camelCaseToTitle(key), realValue: value });
    }
  });

  Object.keys(sourceData.daily).forEach((key) => {
    let prevValue = 0;
    for (const [type, value] of Object.entries(data.monthly[key])) {
      prevValue += value;
      monthlyData.push({ type, value: prevValue, series: camelCaseToTitle(key), realValue: value });
    }
  });

  setDaily(dailyData);
  setWeekly(weeklyData);
  setMonthly(monthlyData);
}

export const Tooltip = (data, t) => {
  const items = data.map((d) => {
    const value = d ? d.mappingData._origin.realValue : d;
    return `
      <div class="item">
        <div>
          <div class="identifier" style="background: ${d.color}"></div>
        </div>
        <div class="title">
          <span>${t(d.name)}</span>
        </div>
        <div class="value">
          <span>${value || 0}</span>
        </div>
      </div>
    `;
  });

  return `
    <div class="custom-tooltip">
      <h4>${data[0] ? data[0].title : ''}</h4>
      ${items.join('')}
    </div >
  `;
};

export const filtersConfig = {
  type: 'dropdown',
  settings: {
    default: 'weekly',
    options: [
      {
        label: 'Dashboard::Daily',
        value: 'daily',
      },
      {
        label: 'Dashboard::Weekly',
        value: 'weekly',
      },
      {
        label: 'Dashboard::Monthly',
        value: 'monthly',
      },
    ],
  },
};

export const DEFAULT_FILTER_VALUE = 'weekly';
